module.exports = __webpack_public_path__ + "static/media/area-welfare-logo.7b972974.png";